import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'antd/dist/reset.css'; // Ant Design v5
import './index.css';         // se quiser estilos globais

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
